export const baseUrlGateway = "https://app.medicmms.vn/v1/";
export const baseURL = "https://carmel-conscionable-nondevotionally.ngrok-free.dev/v1/";
export const baseExportURL = "https://app.medicmms.vn/api";

